import { Theme, SxProps } from '@mui/material';
import { clsx } from '../utils';

export const flexRow = (sx?: SxProps<Theme>): SxProps<Theme> =>
	clsx(
		{
			display: 'flex',
			flexDirection: 'row',
			columnGap: '8px',
		},
		sx
	);

export const flexColumn = (sx?: SxProps<Theme>): SxProps<Theme> =>
	clsx(
		{
			display: 'flex',
			flexDirection: 'column',
			columnGap: '8px',
		},
		sx
	);
